import store from '@/store';
import { i18n } from '@/plugins/i18n';
import { IShader } from '../shader';

class ShaderTranslator {

    public toLocaleText(shaderName: string): string {
        const shader: IShader = store.getters.shaderByName(shaderName);
        const localeText = i18n.t(shader.text).toString();
        return localeText;
    }
}

export const shaderTranslator = new ShaderTranslator();
